module.exports = __webpack_public_path__ + "img/1535863826.1620705f.jpg";